import { render, staticRenderFns } from "./AddGateway.vue?vue&type=template&id=0200cca5&scoped=true&"
import script from "./AddGateway.vue?vue&type=script&lang=js&"
export * from "./AddGateway.vue?vue&type=script&lang=js&"
import style0 from "./AddGateway.vue?vue&type=style&index=0&id=0200cca5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0200cca5",
  null
  
)

export default component.exports